import { WorkDayUserEntity } from '../utils/types';

/**
 * Next window going back in time (same as legacy react-query behavior).
 * Do not stop when `workDaysData` is empty: holidays / no logging in a sprint still
 * must allow `fetchNextPage()` so views can chain up to 8 pages (see SprintReporting).
 */
export function reportsInfiniteNextPageParam(lastPage: {
  from: Date | string;
  to: Date | string;
  workDaysData: WorkDayUserEntity[];
}): { from: Date; to: Date } {
  return {
    from: new Date(new Date(lastPage.from).setUTCHours(0)),
    to: new Date(new Date(lastPage.to).setUTCHours(0)),
  };
}
